import { STATUS } from '../../constants/commonConstants';

export const schematicsInitialStore = {
  getSchematicsStatus: STATUS.IDLE,
  getSchematicsError: undefined,
  priceAndAvailability: {}
};
